<template>
  <span>
    <ul class="any_file_list">
      <!-- 文件列表 -->
      <li v-for="(item,index) in fileList" :key="index" >
        <a
          @click="
              onDownload(item)
            "
            v-if="!item.uploading"
        >
          <i class="el-icon-document" />
          {{ item.name }}
        </a>
        <el-progress v-else style="width:175px;"  :percentage="item.percentage"></el-progress>
        <i
          class="el-icon-close"
          @click="onRemove(item)"
        />
      </li>
    </ul>
  </span>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import bus from '@/utils/bus'

export default {
  props: {

    fileList: {
      type: Array,
      default: () => []
    }

  },
  data(){
    return {

    }
  },
  mounted(){

  },
  methods: {
    ...mapMutations({
      onRemoveFile: 'upload/onRemoveFile'
    }),

    onRemove(file) {
      this.$emit('onRemove', file)
    },

    onDownload(file) {
      this.$emit('onDownload', file)
    }
  },
  destroyed(){
    this.fileMap = null
  }

}
</script>

  <style lang="scss" scoped>

.any_file_list {
    &>li {
        position: relative;
        display: flex;
        align-items: center;
        height: 30px;
        line-height: 30px;
        width: fit-content;
        max-width: 380px;
        padding: 0 5px;
        &:hover {
            background-color: #F5F7FA;
            .el-icon-close {
                display: inline-block;
            }
        }
        &>a {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 10px;
            color: #606266;
        }
        .el-icon-close {
            display: none;
            line-height: inherit;
            cursor: pointer;
        }
    }
}

  </style>
